import { styled } from '@uhg-abyss/web/tools/styled';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { Text } from '@uhg-abyss/web/ui/Text';

export const HeaderWrapper = styled(Flex, {
  alignItems: 'baseline',
  marginBottom: '8px',
  color: '$core.color.brand.60',
  flexWrap: 'nowrap',
  '@media (max-width: 744px)': {
    marginBottom: '0px',
    padding: '16px $md 12px $md',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
  },
});

export const ResultWrapper = styled(Flex, {
  gap: '$xs',
  alignItems: 'center',
  '@media (max-width: 744px)': {
    gap: '4px',
    alignItems: 'start',
  },
});

export const NoResultsFoundContainer = styled('div', {
  '@media (max-width: 744px)': {
    marginLeft: '16px',
  },
});

export const headerTextStyle = {
  '&.abyss-heading-root': {
    display: 'contents !important',
    '@media (max-width: 464px)': {
      fontSize: '$md !important',
      lineHeight: '$md !important',
    },
  },
};

export const HeadingContainer = styled('div', {
  alignItems: 'center',
  display: 'block',

  '& div': {
    display: 'inline-flex',
    marginLeft: '4px',
  },
});

export const ButtonStyle = {
  '@media (max-width: 464px)': {
    top: '2px',
    left: '4px',
  },
};

export const viewAllTextStyle = {
  color: '$core.color.brand.60',
  fontWeight: '$medium',
  fontSize: '12.64px',
  '@media (max-width: 744px)': {
    width: 'max-content',
  },
  '@media (max-width: 464px)': {
    fontWeight: '$medium',
    fontSize: '14.22px',
  },
};

export const LinkWrapper = styled(Flex, {
  marginLeft: '$md',
  '@media (max-width: 744px)': {
    marginLeft: '0px',
  },
});

export const ListWrapper = styled(Flex, {
  gap: '$lg',
  overflowX: 'auto',
  '@media (max-width: 744px)': {
    gap: '$md',
  },
});

export const PopUpDataCardStyle = {
  gap: '0px',
  width: '151px',
  '@media (max-width: 464px)': {
    width: '151px',
  },

  '&.abyss-card-root': {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },

  '.abyss-tooltip-trigger': {
    '& > span': {
      maxWidth: '135px',
      overflow: 'hidden',
      padding: 0,
      textDecoration: 'none',
      textWrap: 'nowrap',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      '@media (max-width: 744px)': {
        maxWidth: '',
      },
      '@media (max-width: 464px)': {
        maxWidth: '',
      },
    },
  },

  '.abyss-text-root': {
    maxWidth: 'fit-content',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    textWrap: 'nowrap',
    '@media (max-width: 744px)': {
      maxWidth: '200px',
    },
  },
};

export const DataCardStyle = {
  '@media (min-width: 465px)': {
    width: '408px',
  },
  '@media (max-width: 464px)': {
    width: '320px',
  },
};

export const CheckBoxDataCardStyle = {
  width: '100%',
  '@media (max-width: 420px)': {
    width: '320px',
  },
  '@media (max-width: 390px)': {
    width: '300px',
  },
};

export const InfoPopoverDrawerStyle = {
  'abyss-modal-close-button': {
    marginTop: '$md',
    marginRight: '8px',
  },
  'abyss-modal-header-container': {
    marginLeft: '$sm',
  },
  'abyss-modal-base-content-container': {
    borderRadius: '20px 20px 0px 0px',
    height: 'auto !important',
  },
  'abyss-modal-base-body': {
    marginLeft: '$lg',
    marginRight: '$lg',
    marginBottom: '$md',
  },
};

export const mixedResultCarouselStyle = (
  count: number,
  width: number,
  isLoading?: boolean,
  isExpandViewAllFFEnabled?: boolean | undefined
) => ({
  'abyss-carousel-root': {
    width: '100%',
    gap: 0,
  },
  'abyss-carousel-swiper-container': {
    display: 'flex',
    willChange: 'transform',
    zIndex: 0,
    width: count === 2 ? '1200px' : '100%',
    margin: 0,
    alignItems: 'end',
  },
  'abyss-carousel-slide-container': {
    position: 'relative',
    marginLeft: isLoading ? '-18px' : undefined,
    width: count <= 2 ? (isExpandViewAllFFEnabled ? '830px' : '100%') : '830px',
    alignItems: 'end',
    '@media (max-width: 464px)': {
      width: '320px',
      marginLeft: '16px',
    },
    height: 'auto',
    gap: '12px',
  },
  'abyss-carousel-minimal-controls': {
    visibility:
      isExpandViewAllFFEnabled && width < 865
        ? 'visible'
        : (count <= 2 && width > 1250) ||
          (count <= 1 && width < 1250) ||
          (count === 2 && width < 1250 && width > 872)
        ? 'hidden'
        : 'visible',
    marginTop: '12px',
    padding: '0px',
    height: '20px',
    'button.abyss-carousel-minimal-pagination-container': {
      padding: ' 0 4px 0 4px',
      display: 'block',
      width: 'auto',
    },
    zIndex: 0,
  },
  'abyss-carousel-minimal-nav-icon-right': {
    width: '20px',
    height: '20px',
    color: '$core.color.brand.100 !important',
  },
  'abyss-carousel-minimal-nav-container-right': {
    width: '20px',
    height: '20px',
    padding: '0px',
    top: '-3px',
  },
  'abyss-carousel-minimal-nav-container-left': {
    width: '20px',
    height: '20px',
    padding: '0px',
    top: '-3px',
  },

  'abyss-carousel-minimal-nav-icon-left': {
    width: '20px',
    height: '20px',
    color: '$core.color.brand.100 !important',
  },
  'abyss-carousel-minimal-pagination-container': {
    padding: '0 8px 0 8px',
  },
});
export const BottomDataCardStyle = {
  '@media (max-width: 464px)': {
    width: '343px',
    pointerEvents: 'auto',
  },
};
export const StyledCardDescriptionContainer = styled('div', {
  width: '311px',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  gap: '8px',
  display: 'flex',
});

export const StyledCardDescription = styled('span', {
  color: '#323334',
  fontFamily: '$primary',
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: '400',
  lineHeight: '20px',
  wordWrap: 'break-word',
});

export const StyledGetCareTextlabel = styled('span', {
  dynamic: ({ cssProps: { disabled } = {} }) => ({
    color: disabled
      ? 'gray'
      : 'var(--button-color-text-label-secondary, #002677)',
    '&:hover, &:focus': {
      color: disabled
        ? 'gray'
        : 'var(--button-color-text-label-secondary, #002677)',
    },
  }),
  fontSize: '14px',
  fontWeight: '700',
  lineHeight: '18px',
  wordWrap: 'break-word',
});

export const StyledGetCareButton = styled('button', {
  dynamic: ({ cssProps: { disabled } = {} }) => ({
    outline: disabled
      ? '1px var(--button-color-border-container-secondary, $core.color.neutral.30) solid'
      : '1px var(--button-color-border-container-secondary, #002677) solid',
    '&:active, &:focus, &:hover': {
      outline: disabled
        ? '1px var(--button-color-border-container-secondary, $core.color.neutral.30) solid'
        : '1px var(--button-color-border-container-secondary, #002677) solid',
    },
  }),
  height: '32px',
  minWidth: '32px',
  paddingLeft: '16px',
  paddingRight: '16px',
  paddingTop: '4px',
  paddingBottom: '4px',
  background: 'var(--button-color-surface-container-secondary-rest, white)',
  borderRadius: '500px',
  outlineOffset: '-1px',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '8px',
  display: 'inline-flex',
  fontFamily: '$primary',
});

export const StyledFindProvidersTextlabel = styled('span', {
  color: 'var(--button-color-text-label-secondary, #002677)',
  fontSize: '14px',
  fontWeight: '700',
  lineHeight: '18px',
  wordWrap: 'break-word',
});

export const StyledFindProvidersButton = styled('button', {
  height: '32px',
  minWidth: '32px',
  fontFamily: '$primary',
  paddingLeft: '16px',
  paddingRight: '16px',
  paddingTop: '4px',
  paddingBottom: '4px',
  background: 'var(--button-color-surface-container-secondary-rest, white)',
  borderRadius: '500px',
  outline: '1px var(--button-color-border-container-secondary, #002677) solid',
  outlineOffset: '-1px',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '8px',
  display: 'inline-flex',
  '&:active, &:focus, &:hover': {
    outline:
      '1px var(--button-color-border-container-secondary, #002677) solid',
  },
});

export const StyledHeadingTextlabel = styled(Text, {
  color: 'var(--UHC-Neutral-Gray-4, #323334)',
  fontFamily: '$primary',
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: '600',
  lineHeight: '20px',
  wordWrap: 'break-word',
  display: 'inline-flex',
  alignItems: 'center',
});

export const StyledSubtitlespan = styled('span', {
  color: 'var(--UHC-Neutral-Gray-4, #323334)',
  fontFamily: '$primary',
  fontSize: '18px',
  fontStyle: 'normal',
  fontWeight: '600',
  lineHeight: '24px',
  wordWrap: 'break-word',
});

export const StyledProviderName = styled('span', {
  color: '#4B4D4F',
  fontSize: '14px',
  fontWeight: '500',
  lineHeight: '18px',
  wordWrap: 'break-word',
});

export const StyledVirtualServiceHeader = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
});

export const StyledCardWrapper = styled('div', {
  dynamic: ({ cssProps: { desktopScreen } = {} }) => ({
    display: desktopScreen ? 'flex' : 'block',
    flexDirection: 'row',
    alignItems: 'center',
  }),
});

export const StyledCardContainer = styled('div', {
  width: '100%',
  height: '40px',
  flexShrink: 0,
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'stretch',
  gap: '8px',
});

export const StyledHeaderRow = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  width: '100%',
  justifyContent: 'space-between',
  '& > *:first-of-type': {
    marginRight: 'auto',
  },
  '& > *:last-of-type': {
    marginLeft: 'auto',
  },
});

export const StyledHeadingButtonGroup = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  gap: '12px',
});
